import PropTypes from 'prop-types'
import { WorkInGolfFormPageQuery, WORKINGOLF_FORM_QUERY } from '@layouts/workingolf-form'
import { fetchSSRData } from '@lib/ssr-fetch'

function WorkInGolfPage(props) {
  const { data: ssrData, ...restProps } = props
  return (
    <WorkInGolfFormPageQuery {...restProps} slug="career-services" form ssrData={ssrData} />
  )
}

WorkInGolfPage.propTypes = {
  data: PropTypes.object,
}

WorkInGolfPage.getInitialProps = async ({ query }) => fetchSSRData({
  query,
  graphqlQuery: WORKINGOLF_FORM_QUERY,
  variables: { slug: 'career-services' },
  transform: (data) => data?.workInGolfFormPageCollection?.items[0] || null,
})

export default WorkInGolfPage
